<template>

  <div class="mt-4">
    <div class="row">
      <div class="col-md-12">
        <b-card class="mt-2 mb-4 shadow-sm">
          <b-form v-unsave-detector @submit.stop.prevent="clickOnValidateBtn">
            <div class="row">
              <div class="col-md-6">
                <label class="font-weight-bolder secondary-color h6">{{ $t('operation.dossier.step1.title') }}</label>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <label class="mb-3">{{ $t('operation.dossier.step1.subtitle') }}</label>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <b-form-group
                  :invalid-feedback="form.titre.invalidFeedback"
                  :label="$t('Titre')"
                  :state="form.titre.state"
                  class="medium-label mb-4"
                  label-for="name-input">
                  <b-form-input
                    id="titre-input"
                    v-model="form.titre.value"
                    :state="form.titre.state"
                    maxlength="250"
                    required
                    type="text"
                    v-on:change="emitChangeValue">
                  </b-form-input>
                </b-form-group>
              </div>

              <div class="col-md-6">
                <b-form-group
                  :invalid-feedback="form.footer.invalidFeedback"
                  :label="$t('Footer')"
                  :state="form.footer.state"
                  class="medium-label mb-4"
                  label-for="footer-input">
                  <b-form-textarea
                    id="footer-input"
                    v-model="form.footer.value"
                    :max-rows="3"
                    :rows="3"
                    :state="form.footer.state"
                    required
                    v-on:change="emitChangeValue">
                  </b-form-textarea>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <b-form-group
                  :invalid-feedback="form.principalColor.invalidFeedback"
                  :label="$t('color.primary')"
                  :state="form.principalColor.state"
                  class="medium-label mb-4"
                  label-for="principal-color-input">
                  <b-form-input
                    id="principal-color-input"
                    v-model="form.principalColor.value"
                    :state="form.principalColor.state"
                    required
                    type="color"
                    v-on:change="emitChangeValue">
                  </b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-6">
                <b-form-group
                  :invalid-feedback="form.secondaryColor.invalidFeedback"
                  :label="$t('color.secondary')"
                  :state="form.secondaryColor.state"
                  class="medium-label mb-4"
                  label-for="secondary-color-input">
                  <b-form-input
                    id="secondary-color-input"
                    v-model="form.secondaryColor.value"
                    :state="form.secondaryColor.state"
                    required
                    type="color"
                    v-on:change="emitChangeValue">
                  </b-form-input>
                </b-form-group>
              </div>

            </div>
            <div class="row">
              <div class="col-md-6">
                <b-form-group
                  :invalid-feedback="form.logo.invalidFeedback"
                  class="medium-label mb-4">
                  <div class="d-flex">
                    <label for="logo-input">
                      {{ $t('Logo') }}
                    </label>
                  </div>
                  <custom-form-file
                    id="logo-input"
                    v-model="form.logo.value"
                    :drop-placeholder="$t('drop-placeholder')"
                    :placeholder="form.logo.value"
                    :state="form.logo.state"
                    accept=".png, .jpeg, .jpg"
                    @preview="imagePreviewLogo = $event"
                  />
                  <div>
                    <img v-if="imagePreviewLogo" :src="imagePreviewLogo" alt="Image preview"
                         class=" mt-1 preview-image"/>
                    <img v-else-if="!imagePreviewLogo&&dossier&&dossier.logo" :src="getFileUrl(dossier.logo.fileUrl)"
                         alt="Image preview" class="preview-image"/>
                  </div>
                </b-form-group>
              </div>
              <div class="col-md-6">
                <b-form-group
                  :invalid-feedback="form.coverPic.invalidFeedback"
                  class="medium-label mb-4">
                  <div class="d-flex">
                    <label for="cover-input">
                      {{ $t('Image.cover') }}
                    </label>
                  </div>
                  <custom-form-file
                    id="cover-input"
                    v-model="form.coverPic.value"
                    :drop-placeholder="$t('drop-placeholder')"
                    :placeholder="form.coverPic.value"
                    :state="form.coverPic.state"
                    accept=".png, .jpeg, .jpg"
                    @preview="imagePreviewCover = $event"
                  />
                  <div>
                    <img v-if="imagePreviewCover" :src="imagePreviewCover" alt="Image preview"
                         class=" mt-1 preview-image"/>
                    <img v-else-if="!imagePreviewCover&&this.dossier && this.dossier.coverImage"
                         :src="getFileUrl(this.dossier.coverImage.fileUrl)"
                         alt="Image preview" class="preview-image"/>
                  </div>
                </b-form-group>
              </div>
            </div>
            <div class="d-flex justify-content-end">
              <b-button type="submit" variant="primary">{{ $t('Save.and.Continue') }}</b-button>
            </div>
          </b-form>
        </b-card>
      </div>
    </div>

  </div>

</template>

<script>
import api from '../../../services/api'
import CustomFormFile from "../../../components/b122/editFields/CustomFormFile.vue";

export default {
  name: "DossierOperationInformations",
  components: {CustomFormFile},

  props: {
    dossierId: Number,
  },

  data() {
    return {
      operationId: this.$route.params.operationId,
      dossier: null,
      form: {
        titre:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        coverPic:
          {
            state: null,
            invalidFeedback: null,
            value: null,
          },
        principalColor:
          {
            state: null,
            invalidFeedback: null,
            value: "#07153C"
          },
        secondaryColor:
          {
            state: null,
            invalidFeedback: null,
            value: "#9E0430"
          },
        logo:
          {
            state: null,
            invalidFeedback: null,
            value: null,
            id: null,
          },
        footer:
          {
            state: null,
            invalidFeedback: null,
            value: null
          }
      },
      imagePreviewLogo: null,
      imagePreviewCover: null,
    }
  },
  emits: ['didContinue', 'didChangeValue'],


  async mounted() {
    await this.fetchData()
  },

  watch: {
    dossierId: {
      handler: async function (newVal, oldVal) {
        if (newVal) {
          await this.fetchData()
        }
      },
      immediate: true
    }
  },
  methods: {

    getUserLogo() {
      api
        .get(`/dossierOperation/getUserLogo/${this.operationId}`)
        .then(response => {
          if (response.data && response.data.id) {
            this.form.logo.value = response.data.filename
            this.imagePreviewLogo = this.getFileUrl(response.data.fileUrl.toString())
            this.form.logo.id = response.data.id
          }
        })
        .catch((error) => {

        })
    },

     getFooter() {
      api
        .get(`/dossierOperation/getFooter/${this.operationId}`)
        .then(response => {
          this.form.footer.value = response.data.toString()
        })
        .catch((error) => {

        })
    },

    getFileUrl(itemUrl) {
      return process.env.SERVER_URL + itemUrl
    },


    previewImage(event, imageType) {
      // Référence au fichier
      const file = event.target.files[0];

      // Utilisation de FileReader pour lire le contenu du fichier
      const reader = new FileReader();

      reader.onload = (e) => {
        // Mise à jour de la prévisualisation de l'image avec le contenu du fichier lu
        if (imageType === "logo") {
          this.imagePreviewLogo = e.target.result;
        } else if (imageType === "cover") {
          this.imagePreviewCover = e.target.result;
        }
      };

      // Lecture du contenu du fichier
      reader.readAsDataURL(file);

      this.emitChangeValue()
    },

    async fetchData() {
      if (this.dossierId) {
        await this.fetchDossier()
      }
      await this.setInitialValues()
    },

    async fetchDossier() {
      await api
        .get(`/dossierOperation/${this.dossierId}`)
        .then(response => {
          this.dossier = response.data
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    },

    async setInitialValues() {
      if (!(this.dossier && this.dossier.logo)) {
        this.getUserLogo()
      }
      if (this.dossierId && this.dossier) {
        this.form.footer.value = this.dossier.footer
        this.form.titre.value = this.dossier.title
        this.form.principalColor.value = this.dossier.primaryColor
        this.form.secondaryColor.value = this.dossier.secondaryColor
        if (this.dossier.logo) {
          this.form.logo.value = this.dossier.logo.filename
          this.imagePreviewLogo = this.getFileUrl(this.dossier.logo.fileUrl.toString())
        }
        if (this.dossier.coverImage) {
          this.form.coverPic.value = this.dossier.coverImage.filename
          this.imagePreviewCover = this.getFileUrl(this.dossier.coverImage.fileUrl.toString())
        }
      } else {
         this.getFooter()
      }
    },

    async emitChangeValue() {
      this.$emit('didChangeValue')
    },

    /** Bouton validate (Etape suivante)
     *  save + redirection vers l'étape 2 de la création d'operation + success toast
     */
    clickOnValidateBtn() {
      this._save(response => {
        this.$emit('didContinue', response.data.id)
      }, () => {
        this.$nextTick(() => {
          if (!this.dossierId) {
            this.successToast("Dossier Opération", 'f.added');
          } else {
            this.successToast(this.form.titre.value, 'f.modified');
          }
        })
      })
    },


    /** Enregistrement des infos de l'operation en db
     *  POST si l'operation n'existe pas - PUT si c'est une modification (type d'operation non modifiable)
     * @param onSuccessClosure (effectuée si l'enregistrement en db fonctionne)
     */
    _save(onSuccessClosure) {
      let data = new FormData()
      data.append('operationId', this.operationId)
      data.append('titre', this.form.titre.value)
      data.append('principalColor', this.form.principalColor.value)
      data.append('secondaryColor', this.form.secondaryColor.value)
      data.append('coverPic', this.form.coverPic.value)
      data.append('logo', this.form.logo.value)
      data.append('footer', this.form.footer.value)
      data.append('logoId', this.form.logo.id)

      api({
        method: this.dossierId ? 'PUT' : 'POST',
        url: this.dossierId ? `dossierOperation/${this.dossierId}` : 'dossierOperation',
        data: data
      })
        .then((response) => {
          if (onSuccessClosure) {
            onSuccessClosure(response);
            this.successToast(this.form.titre.value, this.dossierId ? 'f.modified' : 'f.added');
          }
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {

            this.$router.push({
              name: 'OperationIndex',
              params: {
                message: error.response.data.message
              }
            })
          } else if (error.response.status === 403) {
            const invalidField = error.response.data.invalidField
            this.form[invalidField]['state'] = false
            this.form[invalidField]['invalidFeedback'] = this.$i18n.t(error.response.data.message)
          }
        })
    },

    /** Success toast quand l'operation est créée/modifiée
     */
    successToast(operationName, actionName) {
      this.$bvToast.toast("Dossier opération" + this.$i18n.t(actionName), {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "success",
        solid: true,
      })
    }
  },
}
</script>

<style scoped>

</style>





// WEBPACK FOOTER //
// src/views/operationDossier/dossierOperationCreateSteps/DossierOperationInformations.vue